import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Row, Tooltip, Col, Pagination} from 'antd';
import {Field, reduxForm} from "redux-form";

import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        sorter: (a, b) => a.key - b.key,
        width:'7%'
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        width:"25%"
    },
    {
        title: 'توضیحات',
        dataIndex: 'description',
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width:"10%"
    },
  ];


class FixtureList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1)
        }
    }

    componentWillMount() {
        this.props.getList();
    }

    /*--- pagination ---*/
    handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        this.props.getList({page:pageNumber});
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];

        if(list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push({
                    key: i+1,
                    title : list[i].title,
                    description: list[i].description,
                    action: <Tooltip placement="top" title="ویرایش">
                                <a href={"#/fixture/edit/"+list[i]._id} className="listBtn"><Icon type="edit" /></a>
                            </Tooltip>
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    __onChangeCounter(value) {
        this.setState({
            pageSize:value
        })
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={20}>
                        <Divider orientation="left">لیست خدمات قابل ارائه</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={4} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="plus" href="#/fixture/add">
                            ایجاد خدمت قابل ارائه
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                    بازگشت
                </RTLButton>
            </div>
        );
    }
}

export default FixtureList = reduxForm({
    form: 'list'
})(FixtureList)
